export default (path = '', route = '') => {
  const _path = path.trim() ? `/${path.trim()}` : '';
  return `${route}${_path}`;
};
